import { featureFlags } from '~/utils/featureFlags';

let gatewayInstance = null;
let fastApiInstance = null;

export const registerGatewayClient = (instance) => {
  gatewayInstance = instance;
};

export const registerFastApiClient = (instance) => {
  fastApiInstance = instance;
};

export const getClient = (flagKey) => (featureFlags[flagKey] ? fastApiInstance : gatewayInstance);
